<template>
  <b-container fluid>
    <b-row>
      <b-col md=12 class='no-padding'>
        <div class='home-page-background jumbotron'>
          <p v-if="$store.getters.language === 'SLO'">Skupina raziskovalcev s področja procesiranja naravnega jezika (PNJ) razvija modele za obdelavo naravnega jezika. </p>
          <p v-else>A group of Natural Language Processing (NLP) researchers is developing Models to help you solve NLP tasks.</p>
        </div>
      </b-col>
    </b-row>
    <ModelList/>
    <!--<div id="about-section">
      <hr>
      <b-row>
        <b-col md=12>
          <div class='section-title'>
            <p v-if="$store.getters.language === 'SLO'">O nas</p>
            <p v-else>About us</p>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs=12 lg=4>
          <div id='about-image'>
            <img id='e8-image' v-bind:src="require('../assets/e8-nlp.jpeg')" alt="e8 image">
            <img id='about-logo' v-bind:src="require('../assets/IJS_JSI_logo-01.png')" alt="JSI_logo">
          </div>
        </b-col>
        <b-col xs=12 lg=8>
          <div id='about-text'>
            <p v-if="$store.getters.language === 'SLO'">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            <p v-else>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </div>
        </b-col>
      </b-row>
    </div>-->
  </b-container>
</template>
<script>
import ModelList from './ModelList.vue'
export default{
  name: "HomeComponent",
  components: {
    ModelList
  },
  mounted() {
  this.$http.get(this.$hostname + '/api/news/list_public')
    .then(response => { 
      this.items = response.data
      this.items = this.items.map(item => ({...item}));
    })
    .catch(error => {
      console.error(error);
    });
  },
  data() {
    return {
      items: [],
    };
  },
  methods:{
    
  },
}
</script>

<style lang="scss">
.news-title {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 16px;
}
.news-section-title {
  text-align: center;
  margin-top: 120px;
}
.title {
  text-align: center;
  padding-top: 60px;
}
.news-section {
  display: block;
  background-color: #E1DEDD;
}
.news-item {
  display: block;
  padding: 20px;
}
.home-page-background {
  -webkit-appearance: none;
  -webkit-border-radius: 0px;
  background-image: url("../assets/background.png");
  z-index: -1;
  width: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

$tablet-width: 768px;
$desktop-width: 1024px;


@media (min-width: #{$tablet-width}) and (max-width: #{$desktop-width - 1px}) {
  .home-page-background {
      height: 315px;
  }
}

@media (max-width: 239px) {
  .home-page-background {
      height: 315px;
  }
}

@media (min-width: #{$desktop-width}) {
  .home-page-background {
      height: 315px;
  }
}


.jumbotron p {
  color: #ffffff;
  font-size: 1.0rem;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  max-width: 500px;
  text-align: center;
  font-weight: 600;
  margin: auto;
}

@media (min-width: 768px) {
  .jumbotron p {
      font-size: 1.5rem;
      padding-top: 20px;
  }
}

#about-section {
  margin-left: 10%;
  margin-right: 10%;
  margin-bottom: 55px;

}

.section-title p {
  color: #449971;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
}

hr {
  border: none;
  height: 1px;
  background: #4F6675;
  margin-bottom: 20px;
  margin-top: 55px;
}

#e8-image {
  width: 100%;
}

#about-logo {
  max-width: 120px;
  margin-top: 55px;
}

.input-group-admin {
  margin-left:25%;
  margin-bottom: 20px;
  width: 50%;
  margin-top: 50px;
  font-weight:bold;
}

.center-button {
  text-align: center;
}



</style>